<template>
  <div>
    <vx-card title="Новый товар" class="p-6">
      <vs-input
        class="w-full mb-4"
        v-validate="'required'"
        label="Название"
        name="Название"
        v-model="product.name"
      />
      <span class="text-danger text-sm">{{ errors.first("Название") }}</span>

      <vs-input
        class="w-full mb-4"
        v-validate="'required'"
        label="Описание"
        name="Описание"
        v-model="product.description"
      />
      <span class="text-danger text-sm">{{ errors.first("Описание") }}</span>

      <vs-input
        class="w-full mb-4"
        v-validate="'required'"
        label="Цена, руб."
        name="Цена"
        type="number"
        v-model.number="product.price"
      />
      <span class="text-danger text-sm">{{ errors.first("Цена") }}</span>

      <vs-input
        class="w-full mb-4"
        v-validate="'required'"
        label="Вес, кг."
        name="Вес"
        type="number"
        v-model.number="product.weight"
      />
      <span class="text-danger text-sm">{{ errors.first("Вес") }}</span>

      <picture-input
        ref="pictureInput"
        class="mt-10 z-10"
        width="200"
        height="200"
        margin="1"
        accept="image/jpeg,image/png"
        size="15"
        buttonClass="vs-component vs-button vs-con-loading__container vs-button-primary vs-button-relief"
        :customStrings="{
          upload: '<h1>Загрузить изображение</h1>',
          drag: 'Загрузите изображение',
          change: 'Изменить изображение',
          remove: 'Удалить изображение',
          select: 'Выбрать изображение',
        }"
      >
      </picture-input>

      <vs-button
        @click="createProduct"
        :disabled="!validateForm"
        color="success"
        class="mr-5 vs-con-loading__container"
        ref="loadableButton"
        type="relief"
      >
        Создать
      </vs-button>
    </vx-card>
  </div>
</template>
<script>
import { API_URL } from "@/.env";
import PictureInput from "vue-picture-input";

export default {
  data: () => ({
    BASE_URL: API_URL,
    product: {
      name: "",
      description: "",
      price: 0,
      weight: 0,
    },
  }),
  components: {
    PictureInput,
  },
  watch: {},
  computed: {
    validateForm() {
      return (
        !this.errors.any() &&
        this.product.name !== "" &&
        this.product.description !== "" &&
        this.product.price !== "" &&
        this.product.weight !== ""
      );
    },
  },
  methods: {
    notification(title, message, color) {
      this.$vs.notify({
        title: title,
        text: message,
        color: color,
        position: "top-center",
        time: "4000",
        icon: "delete",
      });
    },
    uploadImage(idProduct) {
      return this.$load(async () => {
        if (this.$refs.pictureInput.file) {
          await this.$api.market.updateImageProduct(idProduct, {
            imageFile: this.$refs.pictureInput.file,
          });
        }
      });
    },
    createProduct() {
      let payload = {
        name: this.product.name,
        description: this.product.description,
        price: this.product.price,
        weight: this.product.weight,
      };

      this.$load(async () => {
        try {
          let res = await this.$api.market.createProduct(payload);

          this.uploadImage(res.data.id).then((response) => {
            if (response) {
              this.notification("Успешно", "Товар создан", "success");
            } else {
              this.notification(
                "Успешно",
                "Товар создан, изображение не добавлено",
                "success"
              );
            }
            this.$router.push({ name: "market-products" });
          });
        } catch (error) {
          this.notification("Ошибка", "Не удалось создать товар", "danger");
        }
      });
    },
  },
  created() {},
  mounted() {},
};
</script>